import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { LastFillDetailsImpl } from "../model/impl/LastFillDetailsImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class LastFillDetailsImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: LastFillDetailsImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.dealId != null) {
      this.baseEncoder.writeStartFid(921, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(921),
        false,
        encodable.dealId,
        streamout,
      );
      this.baseEncoder.writeEndFid(921, streamout);
    }
    /*Object encoding*/
    if (encodable.fillUserId != null) {
      this.baseEncoder.writeStartFid(922, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(922),
        false,
        encodable.fillUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(922, streamout);
    }
    /*Object encoding*/
    if (encodable.lastQty != null) {
      this.baseEncoder.writeStartFid(923, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(923),
        false,
        encodable.lastQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(923, streamout);
    }
    /*Object encoding*/
    if (encodable.lastSettleQty != null) {
      this.baseEncoder.writeStartFid(924, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(924),
        false,
        encodable.lastSettleQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(924, streamout);
    }
    /*Object encoding*/
    if (encodable.tradeDt != null) {
      this.baseEncoder.writeStartFid(925, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(925),
        false,
        encodable.tradeDt,
        streamout,
      );
      this.baseEncoder.writeEndFid(925, streamout);
    }
    /*Object encoding*/
    if (encodable.clientFillSptRt != null) {
      this.baseEncoder.writeStartFid(926, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(926),
        false,
        encodable.clientFillSptRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(926, streamout);
    }
    /*Object encoding*/
    if (encodable.clientFillPts != null) {
      this.baseEncoder.writeStartFid(927, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(927),
        false,
        encodable.clientFillPts,
        streamout,
      );
      this.baseEncoder.writeEndFid(927, streamout);
    }
    /*Object encoding*/
    if (encodable.clientFillSwpPts != null) {
      this.baseEncoder.writeStartFid(928, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(928),
        false,
        encodable.clientFillSwpPts,
        streamout,
      );
      this.baseEncoder.writeEndFid(928, streamout);
    }
    /*Object encoding*/
    if (encodable.clientFillAllInRt != null) {
      this.baseEncoder.writeStartFid(929, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(929),
        false,
        encodable.clientFillAllInRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(929, streamout);
    }
    /*Object encoding*/
    if (encodable.marketFillSptRt != null) {
      this.baseEncoder.writeStartFid(930, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(930),
        false,
        encodable.marketFillSptRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(930, streamout);
    }
    /*Object encoding*/
    if (encodable.marketFillPts != null) {
      this.baseEncoder.writeStartFid(931, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(931),
        false,
        encodable.marketFillPts,
        streamout,
      );
      this.baseEncoder.writeEndFid(931, streamout);
    }
    /*Object encoding*/
    if (encodable.marketFillSwpPts != null) {
      this.baseEncoder.writeStartFid(932, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(932),
        false,
        encodable.marketFillSwpPts,
        streamout,
      );
      this.baseEncoder.writeEndFid(932, streamout);
    }
    /*Object encoding*/
    if (encodable.marketFillAllInRt != null) {
      this.baseEncoder.writeStartFid(933, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(933),
        false,
        encodable.marketFillAllInRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(933, streamout);
    }
    /*Object encoding*/
    if (encodable.dealSettleTenor != null) {
      this.baseEncoder.writeStartFid(934, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(934),
        false,
        encodable.dealSettleTenor,
        streamout,
      );
      this.baseEncoder.writeEndFid(934, streamout);
    }
    /*Object encoding*/
    if (encodable.dealSettleDate != null) {
      this.baseEncoder.writeStartFid(935, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(935),
        false,
        encodable.dealSettleDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(935, streamout);
    }
    /*Object encoding*/
    if (encodable.dealSwpSettleTenor != null) {
      this.baseEncoder.writeStartFid(936, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(936),
        false,
        encodable.dealSwpSettleTenor,
        streamout,
      );
      this.baseEncoder.writeEndFid(936, streamout);
    }
    /*Object encoding*/
    if (encodable.dealSwpSettleDate != null) {
      this.baseEncoder.writeStartFid(937, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(937),
        false,
        encodable.dealSwpSettleDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(937, streamout);
    }
    /*Object encoding*/
    if (encodable.dealState != null) {
      this.baseEncoder.writeStartFid(938, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(938),
        false,
        encodable.dealState,
        streamout,
      );
      this.baseEncoder.writeEndFid(938, streamout);
    }
    /*Object encoding*/
    if (encodable.fillDts != null) {
      this.baseEncoder.writeStartFid(939, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(939),
        false,
        encodable.fillDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(939, streamout);
    }
    /*Object encoding*/
    if (encodable.dealRef != null) {
      this.baseEncoder.writeStartFid(940, streamout);
      this.baseEncoder.writeObject(
        false,
        LastFillDetailsImplEncoder.fidTypeMap.get(940),
        false,
        encodable.dealRef,
        streamout,
      );
      this.baseEncoder.writeEndFid(940, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,LastFillDetailsImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [100, "java.lang.String"],
    [921, "java.lang.String"],
    [922, "java.lang.Long"],
    [923, "java.math.BigDecimal"],
    [924, "java.math.BigDecimal"],
    [925, "java.util.Date"],
    [926, "java.math.BigDecimal"],
    [927, "java.math.BigDecimal"],
    [928, "java.math.BigDecimal"],
    [929, "java.math.BigDecimal"],
    [930, "java.math.BigDecimal"],
    [931, "java.math.BigDecimal"],
    [932, "java.math.BigDecimal"],
    [933, "java.math.BigDecimal"],
    [934, "com.bcdfx.model.Tenor"],
    [935, "java.util.Date"],
    [936, "com.bcdfx.model.Tenor"],
    [937, "java.util.Date"],
    [938, "com.bcdfx.model.OrderDealState"],
    [939, "java.util.Date"],
    [940, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: LastFillDetailsImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 921: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(921),
            streamin,
          );
          encodable.dealId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 922: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(922),
            streamin,
          );
          encodable.fillUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 923: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(923),
            streamin,
          );
          encodable.lastQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 924: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(924),
            streamin,
          );
          encodable.lastSettleQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 925: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(925),
            streamin,
          );
          encodable.tradeDt = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 926: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(926),
            streamin,
          );
          encodable.clientFillSptRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 927: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(927),
            streamin,
          );
          encodable.clientFillPts = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 928: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(928),
            streamin,
          );
          encodable.clientFillSwpPts = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 929: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(929),
            streamin,
          );
          encodable.clientFillAllInRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 930: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(930),
            streamin,
          );
          encodable.marketFillSptRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 931: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(931),
            streamin,
          );
          encodable.marketFillPts = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 932: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(932),
            streamin,
          );
          encodable.marketFillSwpPts = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 933: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(933),
            streamin,
          );
          encodable.marketFillAllInRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 934: {
          /*Object encoding*/
          let val: CubiqTS.Tenor = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(934),
            streamin,
          );
          encodable.dealSettleTenor = <CubiqTS.Tenor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 935: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(935),
            streamin,
          );
          encodable.dealSettleDate = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 936: {
          /*Object encoding*/
          let val: CubiqTS.Tenor = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(936),
            streamin,
          );
          encodable.dealSwpSettleTenor = <CubiqTS.Tenor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 937: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(937),
            streamin,
          );
          encodable.dealSwpSettleDate = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 938: {
          /*Object encoding*/
          let val: CubiqTS.OrderDealState = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(938),
            streamin,
          );
          encodable.dealState = <CubiqTS.OrderDealState>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 939: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(939),
            streamin,
          );
          encodable.fillDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 940: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LastFillDetailsImplEncoder.fidTypeMap.get(940),
            streamin,
          );
          encodable.dealRef = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,LastFillDetailsImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return LastFillDetailsImplEncoder.fidTypeMap.has(fid);
  }
}
